export const favorites = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M1.76 4.26a6 6 0 0 1 8.48 0L12 6l1.76-1.75a6 6 0 1 1 8.48 8.48L12 23 1.76 12.74a6 6 0 0 1 0-8.48Zm7.78.7a5 5 0 1 0-7.08 7.08L12 21.57l9.54-9.53a5 5 0 1 0-7.08-7.08L12 7.43 9.54 4.96Z"/></svg>
`;

export const favoritesActive = `
<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M10.24 4.26a6 6 0 1 0-8.48 8.48L12 23l10.24-10.25a6 6 0 1 0-8.48-8.48L12 6l-1.76-1.75Z"/></svg>
`;
